import { mpfRListsHttp } from "../api/mpf-r-lists-http"

interface HistoryItems {
    ActionCode: string
    AssignedTo: string
    InquiryGUID: string
    InquiryId: number
    ItemCreated: string
    ItemCreatedBy: string
    ItemModified: string
    ItemModifiedBy: string
    PreviousSectionCode: number
    PreviousStatusCode: string
    SectionCode: number
    ServicingBy: string
    StatusCode:string
    UserRole: string,
    eKey: string
    eTag: string,
}
interface HistoryFetchArgs {
    InquiryGUID: string
}
const LIST_NAME = 'InquiryHistoryList'
const COLUMN_NAMES = {
  ActionCode: 'ActionCode',
  AssignedTo: 'AssignedTo',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  InquiryGUID: 'InquiryGUID',
  InquiryID: 'InquiryID',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstName',
  ItemCreatedByLastName: 'ItemCreatedBy/lastName',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  PreviousSectionCode: 'PreviousSectionCode',
  PreviousServicingBy: 'PreviousServicingBy',
  PreviousStatusCode: 'PreviousStatusCode',
  Section:'Section',
  SectionCode: 'SectionCode',
  ServicingBy: 'ServicingBy',
  StatusCode: 'StatusCode',
  UserRole: 'UserRole'
}
const getInquiryHistoryItems = async (
    args: HistoryFetchArgs
  ): Promise<HistoryItems[]> => {
    const list = await mpfRListsHttp().getList(LIST_NAME)
    const filter = `InquiryGUID eq '${args?.InquiryGUID}'`
    const items = await list
      .query()
      .filter(filter)
      .select(COLUMN_NAMES.ActionCode,
        COLUMN_NAMES.AssignedTo,
        COLUMN_NAMES.ItemCreatedByFirstName, 
        COLUMN_NAMES.ItemCreatedByLastName,
        COLUMN_NAMES.ItemCreated,
        COLUMN_NAMES.InquiryGUID,
        COLUMN_NAMES.EKey,
        COLUMN_NAMES.InquiryID,
        COLUMN_NAMES.PreviousSectionCode,
        COLUMN_NAMES.PreviousStatusCode,
        COLUMN_NAMES.PreviousServicingBy,
        COLUMN_NAMES.SectionCode,
        COLUMN_NAMES.ServicingBy,
        COLUMN_NAMES.StatusCode,
        COLUMN_NAMES.UserRole,
        'Section/MetadataValue',
        'PreviousSection/MetadataValue',
        )
      .expand(COLUMN_NAMES.ItemCreatedBy,COLUMN_NAMES.Section,'PreviousSection',COLUMN_NAMES.AssignedTo )
      .orderBy([{ ascending: false, orderBy: COLUMN_NAMES.ItemCreated }])
      .get()
    return [...items] as HistoryItems[]
  }
export {
    type HistoryFetchArgs,
    type HistoryItems,
    LIST_NAME,
    getInquiryHistoryItems,
  }